export const PHOTO_NUM_LIMIT_PER_PAGE = 4;
export const PHOTO_HEADER_DIVIDING_MARK = '-';
export const ITEMS_PER_PAGE_DEFAULT = 10;
export const ITEMS_PER_PAGE_LIMIT = 20;
export const CURRENT_PAGE_DEFAULT = 1;
